import rightArrowIcon from "assets/icons/rightArr.svg";
import "assets/scss/Components/primaryButton.scss";
import { Fragment, useState } from "react";
const PrimaryButton = ({
  id = "",
  text,
  hoveredText,
  onClick,
  className = "",
  isArrow = true,
  disabled = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      id={id}
      type="button"
      className={`button button--outline ${className} ${
        disabled ? "disabled" : ""
      }`}
      onClick={disabled ? null : onClick}
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {!isHovered && <Fragment>{text}</Fragment>}
      {isHovered && <span>{hoveredText ? hoveredText : text}</span>}

      {isArrow && (
        <Fragment>
          <span>&nbsp;&nbsp;</span>
          <img src={rightArrowIcon} alt="Right arrow" height="10" width="10" />
        </Fragment>
      )}
    </button>
  );
};

export default PrimaryButton;
